import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import headerImage from "../../../../assets/img/longarrow.jpg";

const AddProtectionTierDrawer = ({ isOpen, onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    min_value: "",
    max_value: "",
    rate: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    onCreate({
      ...formData,
      min_value: Number(formData.min_value),
      max_value: Number(formData.max_value),
      rate: Number(formData.rate),
    });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add Protection Tier</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Min Value"
            name="min_value"
            type="number"
            value={formData.min_value}
            onChange={handleChange}
            placeholder="Enter min value (e.g. 0)"
          />

          <ReusableInput
            label="Max Value"
            name="max_value"
            type="number"
            value={formData.max_value}
            onChange={handleChange}
            placeholder="Enter max value (e.g. 1000)"
          />

          <ReusableInput
            label="Rate"
            name="rate"
            type="number"
            value={formData.rate}
            onChange={handleChange}
            placeholder="Enter rate (e.g. 0.08)"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize="15px" width="100px" height="40px">
            Cancel
          </GradientButton>

          <GradientButton onClick={handleSubmit} fontSize="15px" width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddProtectionTierDrawer;